import React from 'react';
import { map, isNumber } from 'lodash';
import { array, func, bool } from 'prop-types';
import { Text, Drawer, Icon, Row } from '../../common';
import { GREEN_DARK, WHITE } from '../../../utils/colors';
import './external-factors.css';

function isEven (num) {
    return isNumber(num) && num % 2 === 0;
}

const SaleschannelDrawer = ({ saleschannels, saleschannelDrawer, handleSaleschannelDrawer }) => {
    return (
        <Drawer
            destroyOnClose
            values={['30%', '30%', '100%']}
            title={<Text size={20} text='Tiendas' />}
            closable
            visible={saleschannelDrawer}
            onClose={handleSaleschannelDrawer}
        >
            <div className='table-card'>
                <div
                    className='header-card'
                    style={{
                        paddingLeft: 15,
                        backgroundColor: GREEN_DARK,
                        color: WHITE,
                        gap: 5,
                        alignItems: 'center',
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4
                    }}>
                    <Icon name='darkstore' size={18} color={WHITE} />
                    <div className='cell normal-cell'>Listado de tiendas</div>
                </div>
                {map(saleschannels, ({ label }, index) => {
                    const isLastElement = index === saleschannels.length - 1;
                    const lastElementStyle = isLastElement ? { borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', boxShadow: '0px 4px 6px 0px #0000002E' } : {};

                    return <Row padding={10} backgroundColor={isEven(index) ? '#F4F4F5' : WHITE} style={lastElementStyle}>
                        <Text text={label} />
                    </Row>;
                })}
            </div>
        </Drawer>
    );
};

SaleschannelDrawer.propTypes = {
    saleschannels: array,
    handleSaleschannelDrawer: func,
    saleschannelDrawer: bool
};

export default SaleschannelDrawer;
